import { useMemo } from 'react'
import { createGlobalState } from 'react-use'
import { useGetGachaponDetailsQuery } from 'vvs-gotchi-graphql'
import useGotchiOwner from 'state/vvsgotchi/hooks/useGotchiOwner'

export interface Gachapon {
  loaded: boolean
  gachaponStart: Date
  gachaponEnd: Date
  todayDifferentQuestCount: number
  hasCompletedQuestRequirement: boolean
  isTeamFedToday: boolean
  isGachaReady: boolean
  hasRedeemGacha: boolean
  refresh: () => Promise<void>
}

export const GACHAPON_QUESTS_REQUIREMENT = 2

export const useGachaponPopupShown = createGlobalState<boolean>(false)

const useGachapon = (): Gachapon => {
  const { owner, team, refresh } = useGotchiOwner()

  const { data: gachaDetails } = useGetGachaponDetailsQuery()

  return useMemo(() => {
    const isTeamFedToday = owner?.gachaInfo?.isTeamFedToday && team?.length > 0
    const todayDifferentQuestCount = owner?.gachaInfo?.todayDifferentQuestCount ?? 0
    const hasCompletedQuestRequirement = todayDifferentQuestCount >= GACHAPON_QUESTS_REQUIREMENT
    const isGachaReady = isTeamFedToday && hasCompletedQuestRequirement

    return {
      loaded: !!gachaDetails && !!owner,
      gachaponStart: new Date(gachaDetails?.gachaDetails.startTime),
      gachaponEnd: new Date(gachaDetails?.gachaDetails.endTime),
      todayDifferentQuestCount,
      isTeamFedToday,
      hasCompletedQuestRequirement,
      isGachaReady,
      hasRedeemGacha: isGachaReady && !owner?.gachaInfo?.isGachaEligible,
      refresh,
    }
  }, [owner, team, gachaDetails, refresh])
}

export default useGachapon
